import React, { useState } from "react";
import { useFormik } from "formik";
import { activateCard } from "../../../apis/cards";
import { useNavigate } from "react-router-dom";
import { cardsScheme } from "../../../lib/validations/cardsValidations";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function ActivateCard() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [addCardsInitial, setAddCardsInitial] = useState({
    tagId: "",
    cardNumber: "",
    cardId:"",
  });

  const navigate = useNavigate();

  // useEffect(()=>{
  //   if(id){
  //     editCards(id)
  //   }
  // },[id])

  //  const editCards = async id => {
  //   console.log({IFHHHHHHS:id})
  //     setEditLoader(true)
  //     try {
  //       const res = await getAllCardRequests(id)
  //       console.log({RDSHIHIHIHHIHKHK:res})
  //       if (res.result) {
  //         setAddCardsInitial({
  //           tagId: res.result.tagId,
  //           cardNumber: res.result.cardNumber
  //         })
  //       }
  //     } catch (error) {
  //       console.error('Error fetching Cards:', error)
  //     } finally {
  //       setEditLoader(false)
  //     }
  //   }

  const formik = useFormik({
    initialValues: addCardsInitial,
    enableReinitialize: true,
    validationSchema: cardsScheme,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let res = await activateCard(null, values);

        console.log({ RES12345678987654: res });
        if(res.success){
        setLoading(false);
        formik.resetForm();
        navigate("/cards");
        }else{
          alert(res?.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/cards");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="my-3 p-3 bg-body rounded shadow-sm">
                  <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                    <>
                      <TextInputFormik
                        label="Tag Id"
                        field="tagId"
                        formik={formik}
                      />
                      <TextInputFormik
                        label="Card Id"
                        field="cardId"
                        formik={formik}
                      />
                      <TextInputFormik
                        label="Card Number"
                        field="cardNumber"
                        formik={formik}
                      />
                    </>

                    {/* <div className="d-flex justify-content-end"> */}
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Submit"}
                    </button>
                    {/* </div> */}
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
